export default "### 2021-08-04 - Portal v4.1.3-hotfix1 Galileo  \n---\n\nBugs Fixed  \n-   Older dcp-clients can now deploy jobs to compute groups\n"